import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsElementaryComponent } from './simple-icons-elementary.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsElementaryComponent ],
    exports:      [ SimpleIconsElementaryComponent ],
    bootstrap:    []
})
export class SimpleIconsElementaryModule {}
